<template>
    <div>
        <iframe
            v-if="initialized"
            :src="minutesEditorUrl"
            title="Meeting minutes viewer"
            class="w-full h-screen overflow-auto"
        ></iframe>
    </div>
</template>

<script setup>
import { computed } from 'vue';
const route = useRoute()
const config = useRuntimeConfig();
const publicSiteData = useState('publicSiteData');

// Props
const props = defineProps({
    meeting: {
        type: Object,
        required: true
    }
});

// Computed URL
const minutesEditorUrl = computed(() => {
    return config.public.boardDomain + '/'
        + publicSiteData.value.organization_slug
        + '/public-site-data/meetings/'
        + route.params.meeting_slug + '/minutes';
});

const initialized = computed(() => {
    return !! publicSiteData.value.organization_slug;
})

</script>